import { useQuery } from '@apollo/client';
import OrderValidateQuery from 'ggApp/shared/context/Order/services/cartServiceAPI/order/orderValidate.graphql';

// TODO: will be extended
// note: if its used outside of MixableProductCard, lets move it.
export const useValidateMixCard = ({
    products,
}: {
    products: any[];
}): { loading: boolean; valid: boolean } => {
    const { data, loading } = useQuery(OrderValidateQuery, {
        variables: { products: products || [] },
    });
    const valid = loading ? false : data?.validateMixProductSelection?.valid ?? false;
    return {
        valid,
        loading,
    };
};
